import { createAtom, IAtom } from 'mobx';
import { bind } from './Bind';

// https://mobx.js.org/refguide/extending.html
export class Clock {
    constructor() {
        // creates an atom to interact with the MobX core algorithm
        this.atom = createAtom(
            // first param: a name for this atom, for debugging purposes
            'Clock',
            // second (optional) parameter: callback for when this atom transitions from unobserved to observed.
            this.startTicking,
            // third (optional) parameter: callback for when this atom transitions from observed to unobserved
            // note that the same atom transitions multiple times between these two states
            this.stopTicking
        );
    }

    public get time() {
        // let MobX know this observable data source has been used
        // reportObserved will return true if the atom is currently being observed
        // by some reaction.
        // reportObserved will also trigger the onBecomeObserved event handler (startTicking) if needed
        if (this.atom.reportObserved()) {
            return this.currentDateTime;
        } else {
            // apparantly getTime was called but not while a reaction is running.
            // So, nobody depends on this value, hence the onBecomeObserved handler (startTicking) won't be fired
            // Depending on the nature of your atom
            // it might behave differently in such circumstances
            // (like throwing an error, returning a default value etc)
            return new Date();
        }
    }

    private tick() {
        this.currentDateTime = new Date();
        // let MobX know that this data source has changed
        this.atom.reportChanged();
    }

    @bind
    private startTicking() {
        this.tick(); // initial tick
        this.intervalHandler = window.setInterval(() => this.tick(), 1000);
    }

    @bind
    private stopTicking() {
        if (this.intervalHandler) {
            window.clearInterval(this.intervalHandler);
            delete this.intervalHandler;
        }
    }

    private atom: IAtom;
    private intervalHandler?: number;
    private currentDateTime: Date = new Date();
}
